import { render, staticRenderFns } from "./FormVFRT.vue?vue&type=template&id=4eddaa74&scoped=true"
import script from "./FormVFRT.vue?vue&type=script&lang=js"
export * from "./FormVFRT.vue?vue&type=script&lang=js"
import style0 from "./FormVFRT.vue?vue&type=style&index=0&id=4eddaa74&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eddaa74",
  null
  
)

export default component.exports